"use client";import createIcon from'./util/createIcon';export default createIcon('M21 11H3V9H21V11M21 13H3V15H21V13Z','DragHorizontalVariant');